/**
 * A class to handle toggler functionality
 * @param {object} toggler - The toggler container element
 * @param {object} trigger - The trigger element
 * @param {object} target - The target element to toggle
 */

var Toggler = function( toggler ){

    this.toggler = toggler;
    this.trigger = this.toggler.find('[data-toggler-trigger]');
    this.target = this.toggler.find('[data-toggler-target]');

    this.init();

}

Toggler.prototype.init = function(){

    var self = this;

    // accessibility: make the trigger keyboard-focusable and expose its expanded state
    if( !this.trigger.attr('role') ){
        this.trigger.attr('role', 'button');
    }
    if( !this.trigger.attr('tabindex') ){
        this.trigger.attr('tabindex', '0');
    }
    this.updateAriaExpanded();

    // off click event to avoid multiple click events (descendant elements also trigger the click event)
    this.trigger.off('click').on('click', function(e){
        e.preventDefault();
        self.toggle();
    });

    // support keyboard activation (Enter / Space) since the trigger isn't a native button
    this.trigger.off('keydown').on('keydown', function(e){
        if( e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32 ){
            e.preventDefault();
            self.toggle();
        }
    });

};

Toggler.prototype.toggle = function(){
    this.toggler.toggleClass('is-active');
    this.updateAriaExpanded();
};

Toggler.prototype.updateAriaExpanded = function(){
    this.trigger.attr('aria-expanded', this.toggler.hasClass('is-active') ? 'true' : 'false');
};

export default Toggler;
